module.exports = __webpack_public_path__ + "static/media/my_services_cover.6bb0408c.jpg";